import { FormattedMessage } from '@flipster/i18n';
import { Checkbox } from '@flipster/react/design-system/checkbox';
import { useMountEffect } from '@flipster/react/misc/lifecycle/mount';
import { vstack } from '@flipster/styled-system/patterns';
import { alert } from '@flipster/ui/Alert';
import { getLocalStorage, setLocalStorage } from '@flipster/utils/localStorage';
import segment, { WalletEvent } from '@flipster/utils/segment';

interface MemoAlertProps {
  userId: string;
  required: 'Tag' | 'Memo';
  currency: string;
  network: string;
  onClose?: () => void;
}

export const MemoAlert = ({ userId, currency, network, required, onClose }: MemoAlertProps) => {
  useMountEffect(() => {
    let isChecked = false;
    const storageKey = `flipster.configs.v1.${userId}.${currency}-${network}.skipMemoRequiredConfirm` as const;
    if (getLocalStorage(storageKey)) return;

    const info = {
      Tag: {
        title: <FormattedMessage id='Deposit.r250401.Tag_is_required' />,
        message: (
          <FormattedMessage
            id='Deposit.r250401.Tag_and_Address_required_bottomsheet_notice_with_symbol_and_network'
            values={{ symbol: currency, network }}
          />
        ),
      },
      Memo: {
        title: <FormattedMessage id='Deposit.r250401.Memo_is_required' />,
        message: (
          <FormattedMessage
            id='Deposit.r250401.Memo_and_Address_required_bottomsheet_notice_with_symbol_and_network'
            values={{ symbol: currency, network }}
          />
        ),
      },
    };
    alert.show({
      warn: true,
      title: info[required].title,
      message: (
        <div className={vstack({ gap: '8px', alignItems: 'flex-start' })}>
          {info[required].message}
          <Checkbox
            onChange={(e) => {
              isChecked = e.target.checked;
              if (isChecked) {
                segment.track(WalletEvent.DepositWarningHideClick, { currency, network });
              }
            }}
            css={{ color: 'content.default.level-2' }}
          >
            <FormattedMessage id='Deposit.r250401.Dont_show_warning_again' />
          </Checkbox>
        </div>
      ),
      confirmText: <FormattedMessage id='Reward_hub.r250213.Close' />,
      onConfirm: () => {
        if (isChecked) setLocalStorage(storageKey, true);
        onClose?.();
      },
      onClose,
    });
  });
  return null;
};
